import { call, put, take } from 'redux-saga/effects';

import piecesJSON from '../../../lib/modelBuilder/tests/fixtures/pieces.json';

import ActionTypes from '../constants/pieces';
import { getPiecesSuccess } from '../actions/pieces';
import { PiecesList } from 'lib/modelBuilder/entities/PiecesList';

export function* downloadPiecesFromAPI() {
  if (true || process.env.NODE_ENV !== 'production') {
    // Process the pieces
    const pieces = new PiecesList(JSON.stringify(piecesJSON));

    yield put(getPiecesSuccess(pieces));
    return pieces;
  } else {
    // TODO: get the properties and pieces data from API
    // const url = `${PIECES_URL}/`;
    // try {
    //   const response = yield call(requestGet, url);
    //   const pieces = new PiecesList(response);
    //   yield put(getPiecesSuccess(pieces));
    //   return pieces;
    // } catch (error) {
    //   yield put(getPiecesFailure(error));
    // }
  }
}

export default function* piecesSaga() {
  while (true) {
    yield take(ActionTypes.PIECES_REQUEST);
    yield call(downloadPiecesFromAPI);
  }
}
